'use strict';

/**
 * Walks up the DOM tree to find the nearest scrollable ancestor.
 * Falls back to $('html, body') if none is found.
 *
 * @param {jQuery} $el - The target element to start walking from
 * @returns {jQuery} The nearest scrollable ancestor, or $('html, body')
 */
function getScrollableParent($el) {
    var $parents = $el.parents();
    for (var i = 0; i < $parents.length; i++) {
        var $parent = $($parents[i]);
        var overflowY = $parent.css('overflow-y');
        var isScrollable = overflowY === 'auto' || overflowY === 'scroll';
        if (isScrollable && $parent[0].scrollHeight > $parent[0].clientHeight) {
            return $parent;
        }
    }
    return $('html, body');
}

/**
 * Returns the combined height of any sticky or fixed direct children
 * of a scroll container. Used to offset scroll position so targets
 * are not hidden behind pinned headers.
 *
 * @param {jQuery} $container - The scrollable container to inspect
 * @returns {number} Combined height in px of all sticky/fixed children
 */
function getPinnedHeaderOffset($container) {
    var offset = 0;
    $container.children().each(function () {
        var pos = $(this).css('position');
        if (pos === 'sticky' || pos === 'fixed') {
            offset += $(this).outerHeight() || 0;
        }
    });
    return offset;
}

/**
 * Scrolls to a target element within its nearest scrollable container.
 * Automatically detects the container (sidebar, modal/popup, or page window)
 * and accounts for any sticky or fixed headers inside it.
 * Scrolls the minimum amount needed to bring the target into view:
 * - Scrolls up if target is above the visible area
 * - Scrolls down if target is below the visible area
 * - Does nothing if the target is already fully visible
 *
 * @param {string|jQuery} target - CSS selector string or jQuery object to scroll to
 */
function scrollToElement(target) {
    var $target = $(target);
    if (!$target.length) return;

    var $scrollContainer = getScrollableParent($target);
    var isWindow = $scrollContainer.is($('html, body'));
    var pinnedOffset = getPinnedHeaderOffset($scrollContainer);

    if (isWindow) {
        // Page window: scroll to absolute position minus any fixed page headers
        $scrollContainer.animate({
            scrollTop: $target.offset().top - pinnedOffset
        }, 500);
    } else {
        // Sidebar / modal / popup: scroll only as much as needed to bring target into view
        var visibleTop = $scrollContainer.offset().top + pinnedOffset;
        var visibleBottom = $scrollContainer.offset().top + $scrollContainer.height();
        var targetTop = $target.offset().top;
        var targetBottom = targetTop + $target.outerHeight();

        if (targetTop < visibleTop) {
            // Target is above the visible area — scroll up to bring it to the top
            $scrollContainer.animate({
                scrollTop: $scrollContainer.scrollTop() + (targetTop - visibleTop)
            }, 500);
        } else if (targetBottom > visibleBottom) {
            // Target is below the visible area — scroll down just enough to show it
            $scrollContainer.animate({
                scrollTop: $scrollContainer.scrollTop() + (targetBottom - visibleBottom)
            }, 500);
        }
        // Target already fully visible — no scroll needed
    }
}

/**
 * Scrolls to the first invalid field (.is-invalid) within a given form.
 * Works across all contexts: sidebar, modal/popup, and plain pages.
 *
 * @param {string} formSelector - CSS selector for the form (e.g. '#my-form')
 */
function scrollToFirstInvalidField(formSelector) {
    var $firstInvalid = $(formSelector + ' .is-invalid').first();
    if ($firstInvalid.length > 0) {
        scrollToElement($firstInvalid);
    }
}

module.exports = {
    getScrollableParent: getScrollableParent,
    getPinnedHeaderOffset: getPinnedHeaderOffset,
    scrollToElement: scrollToElement,
    scrollToFirstInvalidField: scrollToFirstInvalidField
};
